import { render, staticRenderFns } from "./AveineWineOfTheMonthForm.vue?vue&type=template&id=54415d30"
import script from "./AveineWineOfTheMonthForm.vue?vue&type=script&lang=js"
export * from "./AveineWineOfTheMonthForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports